<template>
  <div>

    <h2>{{ $t('title.' + action + '.location') }}</h2>

    <el-row :gutter="40">

      <el-col :md="12">

        <data-form
          model="locations"
          :entity="location"
          :fields="fields"
          :before-submit="beforeSubmit"
          :after-submit="afterSubmit" />

      </el-col>

      <el-col :md="12">

        <h4>{{ $t('related-servers') }}</h4>

        <data-table
          model="servers"
          :columns="['fqdn']"
          :isSelected="isServerSelected"
          @selection-change="serverSelectChanged" />

      </el-col>

    </el-row>

  </div>
</template>

<script>
import locationFields from './locationFields'
export default {
  name: 'location-details',
  data () {
    return {
      relatedServers: [],
      fields: locationFields
    }
  },
  computed: {
    location () {
      const id = this.$route.params.id

      if (id === 'new') {
        return { new: true }
      }

      return this.$store.getters['locations/findById'](id, this.$store.dispatch)
    },
    action () {
      return this.location.new ? 'create' : 'edit'
    }
  },
  methods: {
    beforeSubmit (formModel) {
      formModel.relatedServerIds = this.relatedServers.map((i) => i.id)
    },
    afterSubmit (formModel) {
      this.$router.back()
    },
    isServerSelected (server) {
      return server.location_id === this.location.id
    },
    serverSelectChanged (selection) {
      this.relatedServers = selection
    }
  }
}
</script>



// WEBPACK FOOTER //
// LocationDetails.vue?72304b90